module.exports = __webpack_public_path__ + "img/p2-p1-diaoxiang.475e28d8.png";